import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import { Helmet } from 'react-helmet-async';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Box, Button, Center, Flex, Image, Link, Spinner, Text } from '@chakra-ui/react';
import telegram from 'assets/img/logos/TG.svg';
import telegramShort from 'assets/img/logos/tg-short.svg';
import ConnectBrokerInstructionItem
  from 'presentation/components/modules/brokerAccount/create/ConnectBrokerInstructionItem';
import { Color } from 'presentation/theme/colorScheme';
import { useDisconnectTelegramMutation, useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';

const TelegramPage: FC = () => {
  const { t } = useTranslation();
  const { data, isFetching, error, refetch } = useFetchProfileQuery();
  const [disconnectTelegram] = useDisconnectTelegramMutation();
  const steps = [
    <Text key={0}>
      {t('telegramFirst')}
    </Text>,
    <Text key={1}>{t('telegramSecond')}</Text>,
    <Text key={2}>{t('telegramThird')}</Text>,
  ];
  let content;
  if (isFetching) {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  } else if (data) {
    if (!data.isTelegramConnected) {
      content = (<>
          <AppCard mb="20px">
            <Text p="40px">{t('telegramTitle')} <Link href="https://t.me/sharespro_bot" color={Color.Primary500}
                                                      textDecoration="underline">{t('telegramTitleLink')}</Link></Text>
          </AppCard>
          <AppCard mb="20px">
            <Image src={telegram} pt="48px" pl="160px" />
            <Box position="relative" w="100%" mr="10px" px="40px" py="20px">
              <Box>
                {steps.map((stepText, index) => (
                  <Box key={index} mb="25px">
                    <ConnectBrokerInstructionItem
                      hasFormFields={index === 2}
                      step={index + 1}
                    >
                      {stepText}
                    </ConnectBrokerInstructionItem>
                  </Box>
                ))}
              </Box>
              <Box
                py="25px"
                ml="35px"
                position="absolute"
                left="78px"
                top="25px"
                bgColor={Color.Shade100}
                w="2px"
                h="162px"
              />
            </Box>
          </AppCard>
        </>
      );
    } else {
      content = (<AppCard p="40px">
        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignItems="center">
            <Image src={telegramShort} />
            <Text ml="10px" fontWeight={700} color={Color.Primary500}>{t('enabled')}</Text>
          </Flex>
          <Button color={Color.OnPrimary} bgColor={Color.Danger400} fontWeight={600} onClick={event => {
            disconnectTelegram().unwrap().then(
              () => {
                refetch();
              }
            );
          }}>
            {t('disable')}
          </Button>
        </Flex>
      </AppCard>);
    }
  } else if (error) {
    content = (
      <Center>
        <ErrorContainer
          error={error}
          onRetry={() => {
            refetch();
          }}
        />
      </Center>
    );
  } else {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return <>
    <SettingsLayout>
      <Helmet>
        <title>{t('connectionTelegram')}</title>
      </Helmet>
      <GridHeading>{t('connectionTelegram')}</GridHeading>
      {content}
    </SettingsLayout>
  </>;
};

export default TelegramPage;
